import { useModal } from '@topconagriculture/modal';
import { useFarmParams } from './useFarmParams';
import { itemDeviationAlertsModalName } from '../common/DeviationWidget/DeviationWidget';
export const useItemAlertClick = () => {
    const { dispatchOpenModal } = useModal();
    const farmParams = useFarmParams();
    return (id, link, widget) => dispatchOpenModal({
        modalName: itemDeviationAlertsModalName,
        modalParams: { id, farmParams, link, widget },
        modalOptions: {
            modalDialogProps: {
                maxWidth: 'lg',
            },
            closeButtonIsVisible: false,
        },
    });
};
//# sourceMappingURL=useItemAlertClick.js.map